<script setup lang="ts">
import { ref, watch } from 'vue';
import type { PopupEvent } from '@/components/popup/popup/popup';
import type { Emits, Props } from './prompt';
import TopButton from '@/components/forms/button/button.vue';
import TopPopup from '@/components/popup/popup/popup.vue';
import TopPopupWidgetInput from '@/components/popup/popup/widgetInput.vue';

const props = defineProps<Props>();

const emit = defineEmits<Emits>();

const reset = () => localValue.value = props.defaultValue ?? '';

const isSubmit = ref(false);

const localValue = ref();
watch(() => props.defaultValue, () => reset(), { immediate: true });

const onSubmit = () => {
	isSubmit.value = true;
};

const onClose = (popupEvent: PopupEvent) => {
	if (isSubmit.value) {
		isSubmit.value = false;

		emit('submit', localValue.value);

		reset();

		return;
	}

	reset();

	emit('close', popupEvent);
};

const $propsPopup = { ...props, submitText: undefined, cancelText: undefined, defaultValue: undefined };
delete $propsPopup.submitText;
delete $propsPopup.cancelText;
delete $propsPopup.defaultValue;
</script>

<template>
	<TopPopup
		class="top-popupPrompt"
		:=$propsPopup
		@open="$emit('open', $event)"
		@close="onClose($event)"
		@scrollContentList="(...args) => $emit('scrollContentList', ...args)"
	>
		<template #opener>
			<!-- @slot Элемент для открытия TopPopup -->
			<slot name="opener"></slot>
		</template>

		<template #header v-if="$slots.header">
			<!-- @slot Шапка -->
			<slot name="header"></slot>
		</template>

		<template #content v-if="$slots.default">
			<!-- @slot Контент в свободной форме -->
			<slot></slot>

			<TopPopupWidgetInput v-model.trim="localValue"/>
		</template>

		<template #footer>
			<!-- @slot Футер -->
			<slot name="footer"></slot>

			<TopButton color="theme">
				{{ cancelText || $i18n.Common.Cancel }}
			</TopButton>

			<TopButton @click="onSubmit">
				{{ submitText || $i18n.Common.OK }}
			</TopButton>
		</template>
	</TopPopup>
</template>
